import Vue from 'vue';
import Store from '../../lib/stores/store';
import Instance from './instance.html';
import BookingSchedule from './booking-schedule';

if (document.getElementById('bookingSchedule')) {
	const vue = new Vue({
		el: '#bookingSchedule',
		store: Store,
		template: Instance,
		components: {
			BookingSchedule,
		},
	});
}
